/**
 * 通用等待DOM元素出现（纯JS，无依赖）
 * 支持：CSS选择器 | HTMLElement | React useRef 对象
 * @param {string | HTMLElement | { current: HTMLElement | null }} target
 * @param {number} interval - 轮询间隔(ms) 默认200
 * @param {number} maxRetry - 最大重试次数 默认15
 * @returns {Promise<HTMLElement|null>}
 */
export function waitForElement(
  target: string | HTMLElement | { current: HTMLElement | null },
  interval = 200,
  maxRetry = 15,
): Promise<HTMLElement | null> {
  return new Promise(resolve => {
    let retryCount = 0;

    function tryFind() {
      let el: HTMLElement | null = null;

      // 1. 如果是 React ref 对象
      if (target && typeof target === "object" && "current" in target) {
        el = target.current;
      }
      // 2. 如果是已经存在的 DOM 元素
      else if (target instanceof HTMLElement) {
        el = target;
      }
      // 3. 如果是 CSS 选择器
      else if (typeof target === "string") {
        el = document.querySelector(target);
      }

      // 找到元素
      if (el) {
        resolve(el);
        return;
      }

      // 重试次数超限
      retryCount++;
      if (retryCount >= maxRetry) {
        console.warn(`[waitForElement] 超时未找到元素`);
        resolve(null);
        return;
      }

      // 继续轮询
      setTimeout(tryFind, interval);
    }

    tryFind();
  });
}
